import { resolveI18n } from "../../../commons/services/Translation"

export const DetailV2SelectedPannelInfoWidth = (i18n) => {
  return {
    child1: resolveI18n({ i18n, ko: '60px', en: '78px', vi: '78px' }),
    child2: resolveI18n({ i18n, ko: '88px', en: '78px', vi: '78px' }),
    child3: resolveI18n({ i18n, ko: '88px', en: '78px', vi: '78px' }),
  }
}

export const DetailV2PannelInfoCardWidth = (i18n) => {
  return {
    child1: resolveI18n({ i18n, ko: '50px', en: '90px', vi: '90px' }),
    child2: resolveI18n({ i18n, ko: '88px', en: '72px', vi: '72px' }),
    child3: resolveI18n({ i18n, ko: '88px', en: '72px', vi: '72px' }),
  }
}

export const DetailV2InverterCurrentPowerCard = (i18n) => {
  return {
    inputLabelWidth: resolveI18n({ i18n, ko: '60px', en: '120px', vi: '120px' }),
  }
}

export const DetailV2IssueInputLabel = (i18n) => {
  return {
    width: resolveI18n({ i18n, ko: '26px', en: '60px', vi: '100px' }),
  }
}